import type { OlistProducts, OlistProductsOptions } from "types/general";

export const FALLBACK_LANGUAGE = "en";

const lang =
  (!!global.window && window.navigator.language) || FALLBACK_LANGUAGE;

export const languageCode = lang.toLocaleLowerCase();

export const currencyLocale = {
  en: { decimal: ".", symbol: "$", decimalLimit: 2 },
  "en-us": { decimal: ".", symbol: "$", decimalLimit: 2 },
  "pt-br": { decimal: ",", symbol: "R$", decimalLimit: 2 },
  "es-mx": { decimal: ".", symbol: "$", decimalLimit: 2 },
};

const getCurrency = (value, language = "en") => {
  const valueType = typeof value;

  if (valueType === "number") {
    return value.toLocaleString(language, {
      minimumFractionDigits: 2,
    });
  }

  throw Error("value must be number type");
};

export const formatCurrency = (
  value,
  withSign = false,
  language = languageCode
) => {
  const currencyWithLocale =
    currencyLocale[language] || currencyLocale[FALLBACK_LANGUAGE];
  const floatedValue = parseFloat(value);
  if (Number.isNaN(floatedValue)) {
    return `${currencyWithLocale.symbol} ${parseFloat("0").toFixed(
      currencyWithLocale.decimalLimit
    )}`;
  }

  let sign = "";
  if (withSign) {
    sign = floatedValue < 0 ? "- " : "";
  }
  const currencyValue = getCurrency(Math.abs(floatedValue), language);
  return `${sign}${currencyWithLocale.symbol} ${currencyValue}`;
};

export const formatPercentage = (value, language = languageCode) => {
  const currencyWithLocale =
    currencyLocale[language] || currencyLocale[FALLBACK_LANGUAGE];
  const floatedValue = parseFloat(value);
  if (Number.isNaN(floatedValue)) {
    return "0%";
  }

  const sign = floatedValue < 0 ? "-" : "";
  const parsedValue = Math.abs(
    Number(floatedValue.toFixed(currencyWithLocale.decimalLimit))
  );
  const integerValue = parseInt(String(parsedValue), 10);
  const decimal = parsedValue - integerValue;
  const valueFiltered = decimal > 0 ? parsedValue : integerValue;

  return `${sign}${valueFiltered.toLocaleString(languageCode)}%`;
};

export const formatPostCode = (postCode) => {
  const brazilianPattern = /^([\d]{5})([\d]{3})([\d\D]{1,})?/;
  const postCodeStr = (postCode || "").toString();

  if (!postCodeStr) {
    return "";
  }

  return postCodeStr.replace(brazilianPattern, "$1-$2");
};

export const productToTitle: OlistProductsOptions = {
  loja: "Loja",
  erp: "ERP",
  "conta-digital": "Conta Digital",
  envios: "Envios",
  "agentes-de-ia": "Agentes de IA",
  credito: "Crédito",
};

export const productOptions: Array<{ label: string; value: OlistProducts }> = [
  {
    label: "Loja",
    value: "loja",
  },
  {
    label: "ERP",
    value: "erp",
  },
  {
    label: "Conta Digital",
    value: "conta-digital",
  },
  {
    label: "Envios",
    value: "envios",
  },
  {
    label: "Agentes de IA",
    value: "agentes-de-ia",
  },
  {
    label: "Crédito",
    value: "credito",
  },
];
